import {Component, Injector, OnInit} from '@angular/core';
import {Environment} from '../environments/environment.interface';
import {environment} from '../environments/environment';
import {ApplicationConstants} from './common/constants/application.constants';
import {isNullOrUndefined, isStringNullUndefinedOrEmptyWithTrim} from './common/utility';
import {MatIconRegistry} from '@angular/material/icon';
import {DomSanitizer} from '@angular/platform-browser';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

export let InjectorInstance: Injector;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  private readonly SCRIPT_TAG = 'script';
  private BLANK = '';
  private _environment: Environment;
  public showHeaderAndFooter: boolean = true;
  private noHeaderAndFooterRoutes = [
    '/secure/auth-details-report'
  ];

  constructor(
    private injector: Injector,
    private iconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private router: Router
  ) {
    // Capturing an instance of the dependency injector to use in un instantiated classes with static methods
    InjectorInstance = this.injector;
    this._environment = environment;
    this.registerIcons();
  }

  title = 'app';

  ngOnInit(): void {
    this.loadWalkmeLibrary();

    this.router.events
    .pipe(filter(event => event instanceof NavigationEnd))
    .subscribe(() => {

      for (let i=0; i<this.noHeaderAndFooterRoutes.length; i++) {
        if (this.router.url.startsWith(this.noHeaderAndFooterRoutes[i])) {
          this.showHeaderAndFooter = false;
        }
      }

    });
  }

  /**
   * Note this logic was added for ECLAIM-414 to add WalkMe instructional guide into the app.
   * @private
   */
  private loadWalkmeLibrary() {
    if (!isNullOrUndefined(environment) && !isStringNullUndefinedOrEmptyWithTrim(environment.envName) && !isStringNullUndefinedOrEmptyWithTrim(environment.walkmeUrl)) {
      const body = <HTMLDivElement>document.body;
      const walkmeScript = document.createElement(this.SCRIPT_TAG);
      walkmeScript.innerHTML = this.BLANK;
      walkmeScript.async = true;
      walkmeScript.crossOrigin = 'anonymous';
      walkmeScript.src = environment.walkmeUrl;
      body.appendChild(walkmeScript);
    }
  }

  /**
   * Function registers the icon sets with the MatIconRegistry so that the namespaces are accessible in the DOM.
   * @private
   */
  private registerIcons(): void {
    this.iconRegistry.addSvgIconSetInNamespace('eclaim-icons', this.domSanitizer.bypassSecurityTrustResourceUrl('/assets/icons/eclaim-icons.svg'));
    this.iconRegistry.addSvgIconSetInNamespace('vsp-icons', this.domSanitizer.bypassSecurityTrustResourceUrl('/assets/icons/vsp.icons.svg'));
    this.iconRegistry.addSvgIconSetInNamespace('vsp-branding-images', this.domSanitizer.bypassSecurityTrustResourceUrl('/assets/icons/vsp.branding-images.svg'));
  }
}
